import { useLanguage } from "../../providers/LanguageProvider";

const LanguageSet = () => {
  const { language, setLanguage, languages, isLanguageLoading } = useLanguage();

  if (isLanguageLoading) {
    return null; // Or a small loading indicator
  }

    return (
        <>
      <div
        className="container-fluid d-flex justify-content-between align-items-center desktop_view_hide"
        style={{ paddingTop: "4em" }}
      >
                <div className="hindiTransalte mt-3">
          {languages.map((lang) => (
            <button
              key={lang.id}
              onClick={() => setLanguage(lang.language_tag_full)}
              style={{
                fontWeight: language === lang.language_tag_full ? "bolder" : "normal",
              }}
            >
              {lang.language_text_app}
            </button>
          ))}
                        </div>
            </div>
        </>
  );
};

export default LanguageSet;
